import React from 'react';
type ContentProps = {
    children: JSX.Element;
  };
  export const Content = (props: ContentProps) => {
    return <>{props.children}</>;
  };
  